import { render, staticRenderFns } from "./shoe-material.vue?vue&type=template&id=11901524&scoped=true"
import script from "./shoe-material.vue?vue&type=script&lang=js"
export * from "./shoe-material.vue?vue&type=script&lang=js"
import style0 from "./shoe-material.vue?vue&type=style&index=0&id=11901524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11901524",
  null
  
)

export default component.exports